import React from 'react';
import { TextAreaProps } from '../../models';
import styles from './textArea.module.scss';
import IconsColor from '../../util/iconsColor';

const TextArea: React.FC<TextAreaProps> = ({
  label,
  value,
  onChange,
  onBlur,
  placeholder = '',
  disabled = false,
  required = false,
  error,
  warning,
  width = '100%',
  height = '120px',
  rows = 4,
  name,
  id,
  maxLength,
  showCharCount = false,
}) => {
  const textAreaId = id || `textarea-${label.toLowerCase().replace(/\s+/g, '-')}`;
  const currentLength = value.length;
  const showCounter = showCharCount || maxLength;

  return (
    <div
      className={styles.textareaWrapper}
      style={{ width }}
    >
      <label htmlFor={textAreaId} className={styles.textareaLabel}>
        {label}{required && <span className={styles.requiredIndicator}>*</span>}
      </label>

      <div className={styles.textareaContainer}>
        <textarea
          id={textAreaId}
          name={name || textAreaId}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          rows={rows}
          maxLength={maxLength}
          className={styles.textareaField + ' ' + (error ? styles.error : '') + ' ' + (warning ? styles.warning : '') + ' ' + (disabled ? styles.disabled : '')}
          style={{ height }}
        />
      </div>

      {showCounter && (
        <div className={styles.charCount}>
          {currentLength}{maxLength && ` / ${maxLength}`}
        </div>
      )}

      {error && (
        <span className={styles.message + ' ' + styles.errorMessage}>
          <IconsColor iconName="errorIcon" width="16px" height="16px" fillColor="none" strokeColor="currentColor" />
          {error}
        </span>
      )}

      {warning && !error && (
        <span className={styles.message + ' ' + styles.warningMessage}>
          <IconsColor iconName="warningIcon" width="16px" height="16px" fillColor="none" strokeColor="currentColor" />
          {warning}
        </span>
      )}
    </div>
  );
};

export default TextArea;

